import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    redirect: "messages",
    children: [
      {
        path: "messages",
        name: "messages",
        meta: {
          isShow: true,
          title: "消息列表",
        },
        component: () => import("../views/MessageView.vue"),
      },
      {
        path: "ratioList1",
        name: "ratioList1",
        meta: {
          isShow: true,
          title: "丢包统计（基于演绎）",
        },
        component: () => import("../views/RatioListView.vue"),
      },
      {
        path: "ratioList2",
        name: "ratioList2",
        meta: {
          isShow: true,
          title: "丢包统计（基于基准网关）",
        },
        component: () => import("../views/RatioListView2.vue"),
      },
    ],
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
